import { render, staticRenderFns } from "./DocumentCreateForm.vue?vue&type=template&id=72ae6f17&scoped=true&"
import script from "./DocumentCreateForm.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCreateForm.vue?vue&type=style&index=0&id=72ae6f17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae6f17",
  null
  
)

export default component.exports